export class Toast {
  private static container: HTMLElement | null = null;

  static show(message: string, type: 'info' | 'error' | 'success' = 'info', duration: number = 3000) {
    if (!this.container) {
      this.container = document.createElement('div');
      this.container.style.position = 'fixed';
      this.container.style.top = '20px';
      this.container.style.left = '50%';
      this.container.style.transform = 'translateX(-50%)';
      this.container.style.display = 'flex';
      this.container.style.flexDirection = 'column'; // Newest at bottom? Or top? Usually newest at top.
      // If we use column, appending adds to bottom.
      // If we want newest on top, we might want 'column-reverse' or prepend?
      // For now, let's keep column and append, so it grows downwards.
      this.container.style.gap = '10px';
      this.container.style.zIndex = '10000';
      this.container.style.pointerEvents = 'none'; // Allow clicking through container
      document.body.appendChild(this.container);
    }

    // Clear existing toasts (Single Toast Mode)
    this.container.innerHTML = '';

    const toast = document.createElement('div');
    toast.textContent = message;

    // Base styles
    toast.style.padding = '12px 20px';
    toast.style.borderRadius = '6px';
    toast.style.color = '#fff';
    toast.style.fontSize = '14px';
    toast.style.fontWeight = '500';
    toast.style.boxShadow = '0 4px 12px rgba(0,0,0,0.3)';
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(-20px)'; // Start slightly above
    toast.style.transition = 'all 0.3s ease';
    toast.style.maxWidth = '300px';
    toast.style.pointerEvents = 'auto'; // Allow interaction if needed (e.g. close)

    // Type styles
    if (type === 'info') toast.style.background = '#2196f3';
    if (type === 'success') toast.style.background = '#4caf50';
    if (type === 'error') toast.style.background = '#f44336';

    this.container.appendChild(toast);

    // Animate in
    requestAnimationFrame(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateY(0)';
    });

    // Remove after duration
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(-20px)'; // Fade out upwards
      toast.addEventListener('transitionend', () => {
        toast.remove();
        if (this.container && this.container.childNodes.length === 0) {
          // Optional: remove container if empty
        }
      });
    }, duration);
  }
}
